import ArchetypeVisionary from './ArchetypeVisionary'

export default ArchetypeVisionary
// eslint-disable-next-line import/export
export * from './ArchetypeVisionary'
